/**
 * RatingGroup Component
 * Reusable rating input with labels
 */

import React from "react";

const RatingGroup = ({
  label,
  name,
  value,
  onChange,
  labels,
  maxRating = 5,
  required = false,
}) => {
  return (
    <div className="form-group">
      <label>
        {label} {required && "*"}
      </label>
      <div className="rating-group">
        {Array.from({ length: maxRating }, (_, i) => i + 1).map((rating) => (
          <div key={rating} className="rating-item">
            <label className="radio-label">
              <input
                type="radio"
                name={name}
                value={rating}
                checked={value === String(rating)}
                onChange={onChange}
                required={required}
              />
              <span className="rating-number">{rating}</span>
            </label>
            <span className="rating-text">{labels[rating - 1]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatingGroup;
